import React, { useState } from 'react'
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import Orbit from './Orbit';
import { getFirstName } from './helpers';
import { customModalOptionsStyles } from './styles';
import './../App.css';

Modal.setAppElement('#root');

export default function Gaze(props) {
  const [areOptionsOpen, setAreOptionsOpen] = useState(false);
  const [selectedStar, setSelectedStar] = useState(null)

  if (!props.data) return <></>;
  const { data } = props;

  function openOptions(person) {
    console.log(person);
    setSelectedStar(person)
    setAreOptionsOpen(true);
  }

  function closeOptions() {
    setAreOptionsOpen(false);
  }

  return (
    <div className="gaze-container">
      <Modal
        isOpen={areOptionsOpen}
        onRequestClose={closeOptions}
        style={customModalOptionsStyles}
        contentLabel="Options"
        shouldCloseOnOverlayClick={true}
      >
        {selectedStar &&
          <div className='options'>
            <h4>Move {selectedStar.name} to</h4>
            <button onClick={() => props.changeOrbit('daily', selectedStar, closeOptions)}>Daily Orbit</button>
            <button onClick={() => props.changeOrbit('weekly', selectedStar, closeOptions)}>Weekly Orbit</button>
            <button onClick={() => props.changeOrbit('monthly', selectedStar, closeOptions)}>Monthly Orbit</button>
          </div>
        }
      </Modal>
      <div className="gaze">
        <div className="title">
          <div className="title-main">
            <h2>{getFirstName(props.person.name) ?? "my"}VERSE</h2>
          </div>
        </div>
        <div className="orbit-collection">
          <Orbit frequency="monthly" data={data.monthly} openOptions={openOptions} {...props}></Orbit>
          <Orbit frequency="weekly" data={data.weekly} openOptions={openOptions} {...props}></Orbit>
          <Orbit frequency="daily" data={data.daily} openOptions={openOptions} {...props}></Orbit>
        </div>
        <div className="gaze-user-container">
          <div className="gaze-user" onClick={props.showMe}>            
            <p>{props.person.name}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
